export default __webpack_public_path__ + "static/media/84.582e0472.gif";